import { useFormik } from "formik";
import { ICandidateResponseOption } from "../../shared/model/candidate-response-option.model";
import { ICandidateToResourceInstance } from "../../shared/model/candidate-to-resource-instance.model";
import { FieldType } from "../../shared/model/enumerations/field-type.model";

interface IFormikResource {
  initialValues: ICandidateToResourceInstance;
  saveEntityConfirm: (data: ICandidateToResourceInstance) => void;
  candidateToResourceInstance: ICandidateToResourceInstance;
  setErrors: (data: number[]) => void;
  setShowModalConfirm: (data: boolean) => void;
}
export const useFormikResource = (props: IFormikResource) => {
  const { initialValues, setErrors } = props;
  const formik = useFormik<ICandidateToResourceInstance>({
    initialValues,
    enableReinitialize: true,
        onSubmit(values) {
      if (formik.isValid) {
        let candidateResponeOptions: ICandidateResponseOption[] = [];
        values.resourceToInstance?.resource?.fields?.forEach((field) => {
          field.options?.forEach((option) => {
            const response = option.response
              ? option.response.toString()
              : field.fieldType === FieldType.MULTIPLE_CHOICE
              ? "false"
              : "";

            let newCandidateResponse: ICandidateResponseOption = {
              response,
              option,
            };
            if (field.fieldType === FieldType.ATTACHED) {
              const attachedFile = option.attachedFile
                ? option.attachedFile
                : "";
              newCandidateResponse = {
                ...newCandidateResponse,
                attachedFile,
              };
              delete option.attachedFile;
            }

            candidateResponeOptions = [
              ...candidateResponeOptions,
              newCandidateResponse,
            ];
          });
        });

        const entitySave: ICandidateToResourceInstance = {
          ...props.candidateToResourceInstance,
          candidateResponeOptions,
        };
        const errors = validateForm(entitySave);
        if (errors.length > 0) {
          setErrors(errors);
          props.setShowModalConfirm(false);
        } else {
          props.saveEntityConfirm(entitySave);
        }
      } else {
        console.log("Error trying to send form");
      }
    },
  });
  return { formik };
};

const validateForm = (entitySave: ICandidateToResourceInstance) => {
  const fields = entitySave?.resourceToInstance?.resource?.fields;
  const errorsFieldId: number[] = [];
  fields?.forEach((field) => {
    if (field.options?.length === 0) {
      errorsFieldId.push(field.id ? field.id : 0);
    } else {
      if (field.fieldType !== FieldType.MULTIPLE_CHOICE) {
        // Debo validar que todos los options tengan una respuesta
        field?.options?.forEach((option) => {
          const result = entitySave.candidateResponeOptions?.find(
            (candResponse) =>
              candResponse.option?.id === option.id &&
              candResponse.response !== ""
          );
          if (!result) {
            errorsFieldId.push(field.id ? field.id : 0);
          }
        });
      } else {
        const optionsArray = field.options?.map((op) => {
          return op.id;
        });
        const result = entitySave.candidateResponeOptions?.filter(
          (candResponse) =>
            candResponse.option?.id &&
            optionsArray?.indexOf(candResponse.option.id) !== -1
        );
        const isTrueSome = result?.some((item) => item.response === "true");
        if (!isTrueSome) {
          errorsFieldId.push(field.id ? field.id : 0);
        }
      }
    }
  });
  return errorsFieldId;
};
